export default {
  'pages.404.subTitle': 'متأسفانه صفحه‌ای که بازدید کردید وجود ندارد.',
  'pages.404.buttonText': 'بازگشت به صفحه اصلی',
};
